import type { ReleaseManifest } from '@/shared/release-manifest';

export type ReleaseCompatibilityStatus = 'up-to-date' | 'refresh-available' | 'reload-required';

export const classifyReleaseCompatibility = ({
    frontend,
    backend,
}: {
    frontend: ReleaseManifest;
    backend: ReleaseManifest;
}): ReleaseCompatibilityStatus => {
    if (
        frontend.protocolVersion < backend.minSupportedFrontendProtocolVersion ||
        frontend.protocolVersion > backend.protocolVersion
    ) {
        return 'reload-required';
    }

    if (frontend.revision !== backend.revision || frontend.protocolVersion !== backend.protocolVersion) {
        return 'refresh-available';
    }

    return 'up-to-date';
};
